import { FC, useState, useMemo } from 'react'
import styles from 'components/features/coaching/advisorReviewPage/StarsPicker/StarsPicker.styl'
import cn from 'classnames'
import { Controller, useFormContext } from 'react-hook-form'
import SvgIcon from 'components/atoms/SvgIcon'
import StarSvg from 'icons/star.svg'

type StarsPickerProps = {
  value: number
  small?: boolean
  onChange?: (value: number) => void
}
export const StarsPicker: FC<StarsPickerProps> = (props) => {
  const { value, onChange, small } = props
  const [hoverValue, setHoverValue] = useState(-1)

  const children = useMemo(() => {
    return new Array(5).fill(1).map((_, index) => {
      const itemNo = index + 1
      const isActive = hoverValue !== -1 ? hoverValue >= itemNo : value >= itemNo
      return (
        <i
          key={ index }
          className={ cn({
            [styles.item]: true,
            [styles.active]: isActive,
            [styles.small]: small,
            [styles.disabled]: !onChange,
          }) }
          onMouseEnter={ () => !!onChange && setHoverValue(itemNo) }
          onClick={ () => !!onChange && onChange(itemNo) }
        >
          <SvgIcon src={ StarSvg } />
        </i>
      )
    })
  }, [hoverValue, value, onChange, small])

  return (
    <div className={ styles.starsPicker } onMouseLeave={ () => setHoverValue(-1) }>
      { children }
    </div>
  )
}

type StarsPickerControllerProps = {
  name: string
  rules?: {
    required?: boolean
  }
}
export const StarsPickerController: FC<StarsPickerControllerProps> = (props) => {
  const { name, rules } = props
  const { control } = useFormContext<Record<string, any>>()
  return (
    <Controller
      control={ control }
      name={ name }
      rules={ rules }
      render={ ({ field: { value, onChange }}) => (<StarsPicker value={ value } onChange={ onChange } />) }
    />
  )
}

